import windowTpl from './base';

const windowAlertTpl = ( data = {} ) => {
    return windowTpl({ ...data, modCls: 'ck-window-modal-alert' });
};

export { windowTpl, windowAlertTpl }